import {React, useState} from 'react';
import axios from 'axios';
import '../../App.css'
import { Grid, TextField, Box, Button, Paper, Stack, FormControl, FormHelperText, Typography, InputAdornment, IconButton} from '@mui/material';
import {AddBusiness, RestartAlt,VisibilityOff, Visibility} from '@mui/icons-material';
import { BiSave } from "react-icons/bi";
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { authActions } from '../../store/auth-slice';
import validator from 'validator';

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red' , marginLeft: '3px' }}>*</span>
  </span>
);

let company_id = 0;

const initialFValues={
  id: 0,
  name: '',
  address1: '',
  address2: '',
  place: '',
  city: '',
  state: '',
  pinCode: '',
  stdCode: '',
  faxNo: '',
  professionTax: '',
  payrollManager: '',
  email: '',
  PANno: '',
  TANno: '',
  CFOname: '',
  fathersName: '',
  designation: '',
  userName: '',
  password: '',
  confirmPassword: '',
}

function SignupCompanyForm(){

  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const [passwordError, setPasswordError] = useState({error: false, message: ""});
  const [confirmPasswordError, setConfirmPasswordError] = useState({error: false, message: ""});
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validate = () => {
    let temp = {}
    temp.name = values.name ? "" : "This field is required."
    temp.address1 = values.address1 ? "" : "This field is required."
    temp.address2 = values.address2 ? "" : "This field is required."
    temp.place = values.place ? "" : "This field is required."
    temp.city = values.city ? "" : "This field is required."
    temp.state = values.state ? "" : "This field is required."
    temp.pinCode = values.pinCode ? "" : "This field is required."
    temp.stdCode = values.stdCode ? "" : "This field is required."
    temp.faxNo = values.faxNo ? "" : "This field is required."
    temp.professionTax = values.professionTax ? "" : "This field is required."
    temp.payrollManager = values.payrollManager ? "" : "This field is required."
    temp.email = values.email ? "" : "This field is required."
    temp.PANno = values.PANno ? "" : "This field is required."
    temp.TANno = values.TANno ? "" : "This field is required."
    temp.CFOname = values.CFOname ? "" : "This field is required."
    temp.fathersName = values.fathersName ? "" : "This field is required."
    temp.designation = values.designation ? "" : "This field is required."
    temp.userName = values.userName ? "" : "This field is required."
    temp.password = values.password ? "" : "This field is required."
    temp.confirmPassword = values.confirmPassword ? "" : "This field is required"

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }

  const toggleShowPassword1 = () => {
    setShowPassword1(showPassword1 => !showPassword1);
  }
  const toggleShowPassword2 = () => {
    setShowPassword2(showPassword2 => !showPassword2);
  }

  const validatePassword = (password) => {
    if(validator.isStrongPassword(password, {
      minLength: 8, minLowercase: 1,
      minUppercase: 1, minNumbers: 1, minSymbols: 1
    })) {
      setPasswordError({
        error: false,
        message: ""
      });
    } else {
      setPasswordError({
        error: true,
        message: "Not strong password!"
      });
    }
  }

  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    });
     if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
    if(name === 'password') {
      validatePassword(value)
    } else if (name === 'confirmPassword') {
      if(value === values.password) {
        setConfirmPasswordError({
          error: false,
          message: ""
        });
      } else {
        setConfirmPasswordError({
          error: true,
          message: "Password not match!"
        });
      }
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if(validate()) {
      const API_URL = `${process.env.REACT_APP_API_BASE_URL}/company-master/company-definition-form/add-company`;
      axios.post(API_URL, values)
      .then(function (response) {
        company_id = response.data[0].company_id;
        if(response.status === 201) {
          // Clear any existing company logo when creating new company
          dispatch(authActions.clearCompanyLogo());
          localStorage.removeItem('companyLogoBase64');
          localStorage.removeItem('companyLogoURL');
          
          setNotify({
            isOpen: true,
            message: 'Signup Successful!',
            type: 'success'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
          setButtonDisabled(true);
        }
      })
      .catch(function (error) {
        if(error.response.status === 406) {
          setNotify({
            isOpen: true,
            message: error.response.data.error_message,
            type: 'error'
          });
        }
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      });
    }
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px"}}>
      <Paper  sx={{width: "1000px"}} variant="outlined">
        <Grid className="form-title" container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>COMPANY DEFINITION</Typography> </Grid>
          <Grid item> <AddBusiness sx={{width: 45, height: 45}}/> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Stack spacing={2} sx={{margin: "20px"}}>

              <Stack direction="row" className="space-evenly">
                            <Stack sx={{ width: "400px", margin: "20px" }} spacing={3}>
                              <TextField
                                variant="outlined"
                                name="name"
                                label={<RequiredLabel label="Name" />}
                                size="small"
                                value={values.name}
                                onChange={handleInputChange}
                                {...(errors.name && { error: true, helperText: errors.name })}
                              />
              
                              <TextField
                                variant="outlined"
                                name="address1"
                                label={<RequiredLabel label="Address Line 1" />}
                                size="small"
                                value={values.address1}
                                onChange={handleInputChange}
                                {...(errors.address1 && { error: true, helperText: errors.address1 })}
                              />
              
                              <TextField
                                variant="outlined"
                                name="address2"
                                label={<RequiredLabel label="Address Line 2" />}
                                size="small"
                                value={values.address2}
                                onChange={handleInputChange}
                                {...(errors.address2 && { error: true, helperText: errors.address2 })}
                              />
                              <Stack className="form-input-row" direction="row" spacing={2} sx={{ width: "400px" }}>
                                <TextField
                                  variant="outlined"
                                  name="place"
                                  label={<RequiredLabel label="Place" />}
                                  size="small"
                                  value={values.place}
                                  onChange={handleInputChange}
                                  {...(errors.place && { error: true, helperText: errors.place })}
                                />
                                <TextField
                                  variant="outlined"
                                  name="city"
                                  label={<RequiredLabel label="City" />}
                                  size="small"
                                  value={values.city}
                                  onChange={handleInputChange}
                                  {...(errors.city && { error: true, helperText: errors.city })}
                                />
                              </Stack>
              
                              <Stack className="form-input-row" direction="row" spacing={2} sx={{ width: "400px" }}>
                                <TextField
                                  variant="outlined"
                                  name="state"
                                  label={<RequiredLabel label="State" />}
                                  size="small"
                                  value={values.state}
                                  onChange={handleInputChange}
                                  {...(errors.state && { error: true, helperText: errors.state })}
                                />
                                <TextField
                                  variant="outlined"
                                  name="pinCode"
                                  label={<RequiredLabel label="Pin Code" />}
                                  size="small"
                                  value={values.pinCode}
                                  onChange={handleInputChange}
                                  {...(errors.pinCode && { error: true, helperText: errors.pinCode })}
                                />
                              </Stack>
                              <TextField
                                variant="outlined"
                                name="stdCode"
                                label={<RequiredLabel label="STD Code - Telephone" />}
                                size="small"
                                value={values.stdCode}
                                onChange={handleInputChange}
                                {...(errors.stdCode && { error: true, helperText: errors.stdCode })}
                              />
              
                              <TextField
                                variant="outlined"
                                name="faxNo"
                                label={<RequiredLabel label="FAX" />}
                                size="small"
                                value={values.faxNo}
                                onChange={handleInputChange}
                                {...(errors.faxNo && { error: true, helperText: errors.faxNo })}
                              />
                              <TextField
                                variant="outlined"
                                name="professionTax"
                                label={<RequiredLabel label="Profession Tax" />}
                                size="small"
                                value={values.professionTax}
                                onChange={handleInputChange}
                                {...(errors.professionTax && { error: true, helperText: errors.professionTax })}
                              />
                            </Stack>
              
                            <Stack sx={{ width: "400px", margin: "20px" }} spacing={3}>
              
              
                              <TextField
                                variant="outlined"
                                name="payrollManager"
                                label={<RequiredLabel label="Payroll Manager" />}
                                size="small"
                                value={values.payrollManager}
                                onChange={handleInputChange}
                                {...(errors.payrollManager && { error: true, helperText: errors.payrollManager })}
                              />
                              <TextField
                                variant="outlined"
                                name="email"
                                label={<RequiredLabel label="Email" />}
                                size="small"
                                value={values.email}
                                onChange={handleInputChange}
                                {...(errors.email && { error: true, helperText: errors.email })}
                              />
                              <Stack className="form-input-row" direction="row" spacing={2}>
                                <TextField
                                  variant="outlined"
                                  name="PANno"
                                  label={<RequiredLabel label="PAN No." />}
                                  size="small"
                                  value={values.PANno}
                                  onChange={handleInputChange}
                                  {...(errors.PANno && { error: true, helperText: errors.PANno })}
                                />
              
                                <TextField
                                  variant="outlined"
                                  name="TANno"
                                  label={<RequiredLabel label="TAN No." />}
                                  size="small"
                                  value={values.TANno}
                                  onChange={handleInputChange}
                                  {...(errors.TANno && { error: true, helperText: errors.TANno })}
                                />
                              </Stack>
                              <TextField
                                variant="outlined"
                                name="CFOname"
                                label={<RequiredLabel label="Name of Chief Finance Officer" />}
                                size="small"
                                value={values.CFOname}
                                onChange={handleInputChange}
                                {...(errors.CFOname && { error: true, helperText: errors.CFOname })}
                              />
              
                              <TextField
                                variant="outlined"
                                name="fathersName"
                                label={<RequiredLabel label="Father's Name" />}
                                size="small"
                                value={values.fathersName}
                                onChange={handleInputChange}
                                {...(errors.fathersName && { error: true, helperText: errors.fathersName })}
                              />
              
                              <TextField
                                variant="outlined"
                                name="designation"
                                label={<RequiredLabel label="Designation" />}
                                size="small"
                                value={values.designation}
                                onChange={handleInputChange}
                                {...(errors.designation && { error: true, helperText: errors.designation })}
                              />
              
                              <TextField
                                variant="outlined"
                                name="userName"
                                label={<RequiredLabel label="UserName for Login" />}
                                size="small"
                                value={values.userName}
                                onChange={handleInputChange}
                                {...(errors.userName && { error: true, helperText: errors.userName })}
                              />
              
                              <FormControl
                                {...(passwordError.error && { error: true })}>
                                <TextField
                                  variant="outlined"
                                  name="password"
                                  label={<RequiredLabel label="Password" />}
                                  size="small"
                                  type={showPassword1 ? "text" : "password"}
                                  value={values.password}
                                  onChange={handleInputChange}
                                  InputProps={{
                                    endAdornment:
                                      <InputAdornment position='end'>
                                        <IconButton onClick={toggleShowPassword1}>
                                          {showPassword1 ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
              
                                  }}
                                  {...(errors.password && { error: true, helperText: errors.password })}
                                />
                                {passwordError.error && <FormHelperText>{passwordError.message}</FormHelperText>}
                              </FormControl>
              
                              <FormControl
                                {...(confirmPasswordError.error && { error: true })}>
                                <TextField
                                  variant="outlined"
                                  name="confirmPassword"
                                  label={<RequiredLabel label="Confirm Password" />}
                                  size="small"
                                  type={showPassword2 ? "text" : "password"}
                                  value={values.confirmPassword}
                                  onChange={handleInputChange}
                                  InputProps={{
                                    endAdornment:
                                      <InputAdornment position='end'>
                                        <IconButton onClick={toggleShowPassword2}>
                                          {showPassword2 ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
              
                                  }}
                                  {...(errors.confirmPassword && { error: true, helperText: errors.confirmPassword })}
                                />
                                {confirmPasswordError.error && <FormHelperText>{confirmPasswordError.message}</FormHelperText>}
                              </FormControl>
                            </Stack>
                          </Stack>

                  <Grid container className="form-btn-container">
                    <Grid item>
                    <Button className="form-btn" variant="contained" color="error" endIcon={<RestartAlt />} disableElevation onClick={resetForm} disabled={buttonDisabled}>Reset</Button>
                    </Grid>
                    <Grid item>
                    <Button className="form-btn" variant="contained" color="success" endIcon={<BiSave/>} disableElevation type="submit" disabled={buttonDisabled}>Save</Button>
                    </Grid>
                  </Grid>

            </Stack>
        </form>

      </Paper>
      <Notification
        notify={notify}
        setNotify={setNotify} 
      />
    </Box>
  )
}

export default SignupCompanyForm;
